import React, { useEffect } from 'react';
import IPage from '../interfaces/page';
import logging from '../config/logging';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import SMSConfigForm from '../components/sms/SMSConfigForm';

const SMS: React.FunctionComponent<IPage & RouteComponentProps<any>> =
  props => {
    useEffect(() => {
      logging.info(`Loading ${props.name}`);
    }, [props]);

    return (
      <div>
        <SMSConfigForm />
      </div>
    );
  };

export default withRouter(SMS);
